import { useParams } from "react-router-dom";

/**
 * Public quote acceptance page (token in URL).
 * Wire to /api/sale/v1/public_quotation/:token/ when enabling customer self-accept.
 */
export const PublicQuotation = () => {
  const { token } = useParams();
  return (
    <div style={{ padding: 24, maxWidth: 720, margin: "0 auto" }}>
      <h1>Quotation</h1>
      <p>
        This link is valid. Full accept / reject will load quote {token ? "…" : ""} here once
        connected to the public quotation API.
      </p>
    </div>
  );
};
